module.exports = __webpack_public_path__ + "static/media/31.2eed0ee3.JPG";